/** @jsx jsx */
import { jsx, useThemeUI } from "theme-ui";
import { useEffect } from "react";
import { Flex, Box, Heading, Text } from "rebass";
import styled from "styled-components";
import SceneHow from "../components/SceneHow";

import Layout from "../layouts/";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Process() { 
  
  const context = useThemeUI();
  const { theme } = context;
  const projectBgColor = theme?.colors?.backgroundElevation as string;
  const projectTextColor = theme?.colors?.text as string;
  
  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById("hero-section");
      if (heroSection) {
        const rect = heroSection.getBoundingClientRect();
        if (rect.bottom > 0) {
          document.body.classList.add("hero-visible");
          document.body.classList.remove("hero-hidden");
        } else {
          document.body.classList.add("hero-hidden");
          document.body.classList.remove("hero-visible");
        }
      } else {
        document.body.classList.add("hero-hidden");
        document.body.classList.remove("hero-visible");
      }
    };
  
    const heroSection = document.getElementById("hero-section");
    if (heroSection) {
      window.addEventListener("scroll", handleScroll);
      handleScroll(); // Initial check
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    } else {
      document.body.classList.add("hero-hidden");
      document.body.classList.remove("hero-visible");
    }
  }, []);
   
  return (
    <Layout>
    <main>
      <Header bgColor={projectBgColor} textColor={projectTextColor} />
      <Flex
        flexWrap="wrap"
        alignItems="center"
        variant="containerPage"
      >
        <Box width={[1/1]}>
          <Heading as="h3" variant="catHeading">Object Oriented UX</Heading>
          <Heading as="h1" variant="bigTitle" className="uppercase">
            Object-Oriented <br/> UX (OOUX)
          </Heading>
        </Box>
        <Box
          order={[1, 2]}
          width={[1 / 1]}
          mb={[4, 6]}
          sx={{ position: "relative" }}
        >
        <Text as="p" maxWidth="40ch" mt={[4]}>
          Object-Oriented UX (OOUX) is a design philosophy that respects the way people naturally think in objects. It helps designers create digital systems with clear, consistent, and recognizable objects that align with users’ mental models, making complex environments easier to understand and use. <br /> OOUX ensures that digital products are intuitive by identifying core objects, defining their relationships, specifying their actions, and detailing their attributes.
        </Text>
        </Box>
      </Flex> 
      <CanvasWrapper order={[0, 1]} width={[1/1]}>
        <SceneHow />
      </CanvasWrapper>   
        <Footer />
        </main>
      </Layout>
  );
}

const CanvasWrapper = styled(Box)`
  width: 100vw;
  height: 80vh;
  position: absolute;
  top: 0;
  @media only screen and (min-width: 52em) {
    height: 100vh;
  }
`;
